export const styles = {
	csvLinkStyle: {
		textDecoration: 'none',
		marginLeft: 'auto',
	},
}
